var _g, _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 91,
    viewBox: "0 0 71 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5827 84.6689H41.416M38.4577 102.419H62.1244M14.791 46.2105C14.791 40.7183 16.9728 35.4511 20.8563 31.5675C24.7399 27.684 30.0072 25.5022 35.4994 25.5022C40.9915 25.5022 46.2588 27.684 50.1424 31.5675C54.0259 35.4511 56.2077 40.7183 56.2077 46.2105C56.2096 49.5448 55.4032 52.8298 53.8575 55.7842C52.3118 58.7385 50.0729 61.2741 47.3327 63.1736L45.7293 70.7647C45.517 72.1639 44.8102 73.4407 43.7372 74.3634C42.6641 75.2861 41.2959 75.7936 39.8806 75.7939H31.1181C29.7028 75.7936 28.3346 75.2861 27.2615 74.3634C26.1885 73.4407 25.4817 72.1639 25.2694 70.7647L23.666 63.2062C20.9248 61.2999 18.6859 58.7584 17.1404 55.7988C15.5949 52.8391 14.7888 49.5494 14.791 46.2105Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.8613,
    y: 22.2341,
    width: 15.9138,
    height: 4.89655,
    rx: 1.5,
    transform: "rotate(-43.223 53.8613 22.2341)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.9138,
    height: 4.89655,
    rx: 1.5,
    transform: "matrix(-0.728694 -0.68484 -0.68484 0.728694 17.502 22.2341)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0508,
    y: 15.9114,
    width: 15.9138,
    height: 4.89655,
    rx: 1.5,
    transform: "rotate(-89.0017 33.0508 15.9114)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(0 19.5856)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/TourIcon.a1314b3b83f2d13541cef280c15de84b.svg";
export { ForwardRef as ReactComponent };